// Eén themalijst per tabblad, niet één per pagina.
//
// `getThemes` is de zwaarste aanroep van Intelligence (cross-tenant scans over
// effecten, mechanismen, cellen, interviews en inzichten). De lijst, het
// themadetail, het celdetail en de inzichtpagina mounten alle vier useThemes,
// dus zonder cache betaalt één klikpad list → thema → cel → terug de scan
// vier keer. Zelfde recept als sectorPathsCache: de PROMISE wordt bewaard
// (twee gelijktijdige mounts delen één aanroep), een mislukte aanroep niet.
//
// De cache verloopt na TTL en wordt geleegd na elke schrijfactie op een
// inzicht (intelligenceWrites), want de tellingen per thema veranderen dan.
// AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook

const TTL_MS = 5 * 60 * 1000

/** @type {{promise: Promise<object>, at: number}|null} */
let entry = null

/**
 * @param {() => Promise<object>} loader - doet de daadwerkelijke aanroep
 * @param {{now?: () => number}} [opties] - injecteerbaar voor tests
 * @returns {Promise<object>}
 */
export const cachedThemes = (loader, { now = Date.now } = {}) => {
    if (entry && now() - entry.at < TTL_MS) return entry.promise
    const promise = loader().catch((err) => {
        if (entry && entry.promise === promise) entry = null
        throw err
    })
    entry = { promise, at: now() }
    return promise
}

/** Na een schrijfactie op een inzicht, en in tests. */
export const invalidateThemesCache = () => { entry = null }

export default cachedThemes
